export const activeSamplingColumns: TableColumn[] = [
  
    {
        Header: 'activeSamplingColumns.Sl.No',
        accessor: 'slno',
      },
      {
        Header: 'Production Schedule',
        accessor: 'production_schedule',
      },
      {
        Header: 'Product Name',
        accessor: 'product_name',
      },
      {
        Header: 'Area Name',
        accessor: 'area',
      },
      {
        Header: 'activeSamplingColumns.Location',
        accessor: 'location',
      },
      {
        Header: 'activeSamplingColumns.Serial Number',
        accessor: 'serial_number',
      },

      {
        Header: 'activeSamplingColumns.Batch Code',
        accessor: 'batch_number',
      },
      {
        Header: 'tableCommon.lot_code',
        accessor: 'lot_code',
      },
      {
        Header: 'activeSamplingColumns.Equipment Code',
        accessor: 'area_code',
      },
      {
        Header: 'activeSamplingColumns.Activity Started By',
        accessor: 'sampling_started_by',
      },
      {
        Header: 'activeSamplingColumns.Activity Started Date',
        accessor: 'start_date_time',
      },
      {
        Header: 'Activity End Date',
        accessor: 'activity_end_date_time',
      },
      {
        Header: 'activeSamplingColumns.Activity Duration',
        accessor: 'sampling_duration',
      },
      {
        Header: 'activeSamplingColumns.First Incubation Start By',
        accessor: 'incubation_started_by',
      },
      {
        Header: 'activeSamplingColumns.First Incubation Start Date',
        accessor: 'incubation_start_date',
      },
      {
        Header: 'activeSamplingColumns.First Incubation End By',
        accessor: 'incubation_end_by',
      },
      {
        Header: 'activeSamplingColumns.First Incubation End Date',
        accessor: 'incubation_end_date',
      },
      {
        Header: 'activeSamplingColumns.First Incubation Duration',
        accessor: 'incubation_duration',
      },
      {
        Header: 'activeSamplingColumns.Second Incubation Start By',
        accessor: 'incubation2_started_by',
      },
      {
        Header: 'activeSamplingColumns.Second Incubation Start Date',
        accessor: 'incubation2_start_date',
      },
      {
        Header: 'activeSamplingColumns.Second Incubation End By',
        accessor: 'incubation2_end_by',
      },
      {
        Header: 'activeSamplingColumns.Second Incubation End Date',
        accessor: 'incubation2_end_date',
      },
      {
        Header: 'activeSamplingColumns.Second Incubation Duration',
        accessor: 'incubation2_duration',
      },
      {
        Header: 'activeSamplingColumns.Observer 1 Name',
        accessor: 'observer1_name',
      },
      {
        Header: 'activeSamplingColumns.Count 1',
        accessor: 'count1',
      },
      {
        Header: 'activeSamplingColumns.Observer 2 Name',
        accessor: 'observer2_name',
      },
      {
        Header: 'activeSamplingColumns.Count 2',
        accessor: 'count2',
      },
      {
        Header: 'activeSamplingColumns.Observer 3 Name',
        accessor: 'observer3_name',
      },
      {
        Header: 'activeSamplingColumns.Count 3',
        accessor: 'count3',
      },
      {
        Header: 'activeSamplingColumns.Approved By',
        accessor: 'approved_id',
      },
  ];

export const passiveSamplingColumns: TableColumn[] = [
  {
      Header: 'passiveSamplingColumns.Sl.No',
      accessor: 'slno',
    },
    {
        Header: 'Production Schedule',
        accessor: 'production_schedule',
      },
      {
        Header: 'Product Name',
        accessor: 'product_name',
      },
      {
        Header: 'Area Name',
        accessor: 'area',
      },
    {
      Header: 'passiveSamplingColumns.Location',
      accessor: 'location',
    },
    {
      Header: 'passiveSamplingColumns.Serial Number',
      accessor: 'serial_number',
    },
    {
      Header: 'passiveSamplingColumns.Batch Code',
      accessor: 'batch_number',
    },
    {
      Header: 'tableCommon.lot_code',
      accessor: 'lot_code',
    },
    {
      Header: 'passiveSamplingColumns.Location Code',
      accessor: 'area_code',
    },
    {
      Header: 'passiveSamplingColumns.Activity Started By',
      accessor: 'started_by'
    },
    {
      Header: 'passiveSamplingColumns.Activity Started Date',
      accessor: 'start_date_time',
    },
    {
        Header: 'Activity End Date',
        accessor: 'activity_end_date_time',
      },
    {
      Header: 'passiveSamplingColumns.Activity Duration',
      accessor: 'sampling_duration',
    },
    {
      Header: 'passiveSamplingColumns.First Incubation Start By',
      accessor: 'incubation_started_by',
    },
    {
      Header: 'passiveSamplingColumns.First Incubation Start Date',
      accessor: 'incubation_start_date',
    },
    {
      Header: 'passiveSamplingColumns.First Incubation End By',
      accessor: 'incubation_end_by',
    },
    {
      Header: 'passiveSamplingColumns.First Incubation End Date',
      accessor: 'incubation_end_date',
    },
    {
      Header: 'passiveSamplingColumns.First Incubation Duration',
      accessor: 'incubation_duration',
    },
    {
      Header: 'passiveSamplingColumns.Second Incubation Start By',
      accessor: 'incubation2_started_by',
    },
    {
      Header: 'passiveSamplingColumns.Second Incubation Start Date',
      accessor: 'incubation2_start_date',
    },
    {
      Header: 'passiveSamplingColumns.Second Incubation End By',
      accessor: 'incubation2_end_by',
    },
    {
      Header: 'passiveSamplingColumns.Second Incubation End Date',
      accessor: 'incubation2_end_date',
    },
    {
      Header: 'passiveSamplingColumns.Second Incubation Duration',
      accessor: 'incubation2_duration',
    },
    {
      Header: 'passiveSamplingColumns.Observer 1 Name',
      accessor: 'observer1_name',
    },
    {
      Header: 'passiveSamplingColumns.Count 1',
      accessor: 'count1',
    },
    {
      Header: 'passiveSamplingColumns.Observer 2 Name',
      accessor: 'observer2_name',
    },
    {
      Header: 'passiveSamplingColumns.Count 2',
      accessor: 'count2',
    },
    {
      Header: 'passiveSamplingColumns.Observer 3 Name',
      accessor: 'observer3_name',
    },
    {
      Header: 'passiveSamplingColumns.Count 3',
      accessor: 'count3',
    },
    {
      Header: 'passiveSamplingColumns.Approved By',
      accessor: 'approved_id',
    },
  
];

export const personnelMonitoringColumns: TableColumn[] = [
  {
      Header: 'personnelMonitoringColumns.Sl.No',
      accessor: 'slno',
    },
    {
        Header: 'Production Schedule',
        accessor: 'production_schedule',
      },
      {
        Header: 'Product Name',
        accessor: 'product_name',
      },
    {
      Header: 'Operator Name',
      accessor: 'operator_id',
    },
    {
      Header: 'personnelMonitoringColumns.Plate Serial Number',
      accessor: 'plate_id',
    },
    {
      Header: 'personnelMonitoringColumns.Batch Code',
      accessor: 'batch_number',
    },
    {
      Header: 'tableCommon.lot_code',
      accessor: 'lot_code',
    },
    {
      Header: 'personnelMonitoringColumns.Finger Dabbed By',
      accessor: 'person_name',
    },
    {
      Header: 'Area Name',
      accessor: 'location',
    },
    {
      Header: 'personnelMonitoringColumns.Monitoring Type',
      accessor: 'monitoring_type',
    },
    {
      Header: 'personnelMonitoringColumns.Activity Start Date',
      accessor: 'sampling_start_date',
    },
    {
      Header: 'personnelMonitoringColumns.First Incubation Start By',
      accessor: 'incubation_started_by',
    },
    {
      Header: 'personnelMonitoringColumns.First Incubation Start Date',
      accessor: 'incubation_start_date',
    },
    {
      Header: 'personnelMonitoringColumns.First Incubation End By',
      accessor: 'incubation_end_by',
    },
    {
      Header: 'personnelMonitoringColumns.First Incubation End Date',
      accessor: 'incubation_end_date',
    },
    {
      Header: 'personnelMonitoringColumns.First Incubation Duration',
      accessor: 'incubation_duration',
    },
    {
      Header: 'personnelMonitoringColumns.Second Incubation Start By',
      accessor: 'incubation2_started_by',
    },
    {
      Header: 'personnelMonitoringColumns.Second Incubation Start Date',
      accessor: 'incubation2_start_date',
    },
    {
      Header: 'personnelMonitoringColumns.Second Incubation End By',
      accessor: 'incubation2_end_by',
    },
    {
      Header: 'personnelMonitoringColumns.Second Incubation End Date',
      accessor: 'incubation2_end_date',
    },
    {
      Header: 'personnelMonitoringColumns.Second Incubation Duration',
      accessor: 'incubation2_duration',
    },
    {
      Header: 'personnelMonitoringColumns.Observer 1 Name',
      accessor: 'observer1_name',
    },
    {
      Header: 'personnelMonitoringColumns.Count 1',
      accessor: 'count1',
    },
    {
      Header: 'personnelMonitoringColumns.Observer 2 Name',
      accessor: 'observer2_name',
    },
    {
      Header: 'personnelMonitoringColumns.Count 2',
      accessor: 'count2',
    },
    {
      Header: 'personnelMonitoringColumns.Observer 3 Name',
      accessor: 'observer3_name',
    },
    {
      Header: 'personnelMonitoringColumns.Count 3',
      accessor: 'count3',
    },
    {
      Header: 'personnelMonitoringColumns.Approved By',
      accessor: 'approved_id',
    },
  
];
//Surface Monitoring - Swab Collection Report 
export const surfaceMonitoringColumns: TableColumn[] = [
  {
      Header: 'surfaceMonitoringColumns.Sl.No',
      accessor: 'slno',
    },
    {
        Header: 'Production Schedule',
        accessor: 'production_schedule',
      },
      {
        Header: 'Product Name',
        accessor: 'product_name',
      },
    {
      Header: 'Area Name',
      accessor: 'area',
    },
    {
      Header: 'surfaceMonitoringColumns.Location',
      accessor: 'location',
    },
    {
      Header: 'surfaceMonitoringColumns.Serial Number',
      accessor: 'plate_number',
    },
    {
      Header: 'surfaceMonitoringColumns.Batch Code',
      accessor: 'batch_number',
    },
    {
      Header: 'tableCommon.lot_code',
      accessor: 'lot_code',
    },
    {
      Header: 'surfaceMonitoringColumns.Saline Tube Serial',
      accessor: 'test_tube_number',
    },
    {
      Header: 'surfaceMonitoringColumns.Swab Stick Serial',
      accessor: 'swab_stick_serial',
    },
    {
      Header: 'surfaceMonitoringColumns.Activity Done By',
      accessor: 'first_name',
    },
    {
      Header: 'surfaceMonitoringColumns.Date Time',
      accessor: 'start_date_time',
    },
    {
      Header: 'surfaceMonitoringColumns.First Incubation Start By',
      accessor: 'incubation_started_by',
    },
    {
      Header: 'surfaceMonitoringColumns.First Incubation Start Date',
      accessor: 'incubation_start_date',
    },
    {
      Header: 'surfaceMonitoringColumns.First Incubation End By',
      accessor: 'incubation_end_by',
    },
    {
      Header: 'surfaceMonitoringColumns.First Incubation End Date',
      accessor: 'incubation_end_date',
    },
    {
      Header: 'surfaceMonitoringColumns.First Incubation Duration',
      accessor: 'incubation_duration',
    },
    {
      Header: 'surfaceMonitoringColumns.Second Incubation Start By',
      accessor: 'incubation2_started_by',
    },
    {
      Header: 'surfaceMonitoringColumns.Second Incubation Start Date',
      accessor: 'incubation2_start_date',
    },
    {
      Header: 'surfaceMonitoringColumns.Second Incubation End By',
      accessor: 'incubation2_end_by',
    },
    {
      Header: 'surfaceMonitoringColumns.Second Incubation End Date',
      accessor: 'incubation2_end_date',
    },
    {
      Header: 'surfaceMonitoringColumns.Second Incubation Duration',
      accessor: 'incubation2_duration',
    },
    {
      Header: 'surfaceMonitoringColumns.Observer 1 Name',
      accessor: 'observer1_name',
    },
    {
      Header: 'surfaceMonitoringColumns.Count 1',
      accessor: 'count1',
    },
    {
      Header: 'surfaceMonitoringColumns.Observer 2 Name',
      accessor: 'observer2_name',
    },
    {
      Header: 'surfaceMonitoringColumns.Count 2',
      accessor: 'count2',
    },
    {
      Header: 'surfaceMonitoringColumns.Observer 3 Name',
      accessor: 'observer3_name',
    },
    {
      Header: 'surfaceMonitoringColumns.Count 3',
      accessor: 'count3',
    },
    {
      Header: 'surfaceMonitoringColumns.Approved By',
      accessor: 'approved_id',
    },   
  
];

export const equipmentConfigurationColumns: TableColumn[] = [
  {
      Header: 'equipmentConfigurationColumns.Sl.No',
      accessor: 'slno',
    },
    {
      Header: 'equipmentConfigurationColumns.Equipment Name',
      accessor: 'name',
    },
    {
      Header: 'equipmentConfigurationColumns.Equipment Code',
      accessor: 'equipment_code',
    },
    {
      Header: 'equipmentConfigurationColumns.Calibaration Date',
      accessor: 'startDate',
    },
    {
      Header: 'equipmentConfigurationColumns.Calibaration Due Date',
      accessor: 'endDate',
    },
    {
      Header: 'equipmentConfigurationColumns.Min Temperature',
      accessor: 'min_temp',
    },
    {
      Header: 'equipmentConfigurationColumns.Max Temperature',
      accessor: 'max_temp',
    },
  
];

export const plateActivityColumns: TableColumn[] = [
  {
      Header: 'plateActivityColumns.Sl.No',
      accessor: 'slno',
    },
    {
      Header: 'plateActivityColumns.Date',
      accessor: 'logDate',
    },
    {
      Header: 'plateActivityColumns.User',
      accessor: 'name',
    },
    {
      Header: 'plateActivityColumns.Action',
      accessor: 'action',
    },
    {
      Header: 'plateActivityColumns.Location',
      accessor: 'location',
    },
    {
      Header: 'plateActivityColumns.Description',
      accessor: 'description',
    },
    {
      Header: 'plateActivityColumns.Reasons',
      accessor: 'reason',
    },
  
];

//Surface Monitoring 
export const surfaceMonitoringReport: TableColumn[] = [
  {
      Header: 'surfaceMonitoringReport.Sl.No',
      accessor: 'slno',
    },
    {
      Header: 'Production Schedule',
      accessor: 'production_schedule',
    },
    {
      Header: 'Product Name',
      accessor: 'product_name',
    },
    {
      Header: 'Area Name',
      accessor: 'area',
    },
    {
      Header: 'surfaceMonitoringReport.Location',
      accessor: 'location',
    },
    {
      Header: 'surfaceMonitoringReport.Serial Number',
      accessor: 'plate_number',
    },
    {
      Header: 'surfaceMonitoringReport.Batch Code',
      accessor: 'batch_number',
    },
    {
      Header: 'tableCommon.lot_code',
      accessor: 'lot_code',
    },
    {
      Header: 'surfaceMonitoringReport.Activity Done By',
      accessor: 'first_name',
    },
    {
      Header: 'surfaceMonitoringReport.Date Time',
      accessor: 'start_date_time',
    },
    {
      Header: 'surfaceMonitoringReport.Incubation Start By',
      accessor: 'incubation_started_by',
    },
    {
      Header: 'surfaceMonitoringReport.Incubation Start Date',
      accessor: 'incubation_start_date',
    },
    {
      Header: 'surfaceMonitoringReport.Incubation End By',
      accessor: 'incubation_end_by',
    },
    {
      Header: 'surfaceMonitoringReport.Incubation End Date',
      accessor: 'incubation_end_date',
    },
    {
      Header: 'surfaceMonitoringReport.Incubation Duration',
      accessor: 'incubation_duration',
    },
    {
      Header: 'surfaceMonitoringReport.Second Incubation Start By',
      accessor: 'incubation2_started_by',
    },
    {
      Header: 'surfaceMonitoringReport.Second Incubation Start Date',
      accessor: 'incubation2_start_date',
    },
    {
      Header: 'surfaceMonitoringReport.Second Incubation End By',
      accessor: 'incubation2_end_by',
    },
    {
      Header: 'surfaceMonitoringReport.Second Incubation End Date',
      accessor: 'incubation2_end_date',
    },
    {
      Header: 'surfaceMonitoringReport.Second Incubation Duration',
      accessor: 'incubation2_duration',
    },
    {
      Header: 'surfaceMonitoringReport.Observer 1 Name',
      accessor: 'observer1_name',
    },
    {
      Header: 'surfaceMonitoringReport.Count 1',
      accessor: 'count1',
    },
    {
      Header: 'surfaceMonitoringReport.Observer 2 Name',
      accessor: 'observer2_name',
    },
    {
      Header: 'surfaceMonitoringReport.Count 2',
      accessor: 'count2',
    },
    {
      Header: 'surfaceMonitoringReport.Observer 3 Name',
      accessor: 'observer3_name',
    },
    {
      Header: 'surfaceMonitoringReport.Count 3',
      accessor: 'count3',
    },
    {
      Header: 'surfaceMonitoringReport.Approved By',
      accessor: 'approved_id',
    },
  
];

export const glovePortReport: TableColumn[] = [ 
  {
      Header: 'surfaceMonitoringReport.Sl.No',
      accessor: 'slno',
    },
    {
        Header: 'Production Schedule',
        accessor: 'production_schedule',
      },
      {
        Header: 'Product Name',
        accessor: 'product_name',
      },
    {
      Header: 'Area Name',
      accessor: 'area',
    },
    {
      Header: 'surfaceMonitoringReport.Location',
      accessor: 'location',
    },
    {
      Header: 'surfaceMonitoringReport.Serial Number',
      accessor: 'plate_number',
    },
    {
      Header: 'surfaceMonitoringReport.Batch Code',
      accessor: 'batch_number',
    },
    {
      Header: 'tableCommon.lot_code',
      accessor: 'lot_code',
    },
    {
      Header: 'surfaceMonitoringReport.Activity Done By',
      accessor: 'first_name',
    },
    {
      Header: 'surfaceMonitoringReport.Date Time',
      accessor: 'start_date_time',
    },
    {
      Header: 'surfaceMonitoringReport.Incubation Start By',
      accessor: 'incubation_started_by',
    },
    {
      Header: 'surfaceMonitoringReport.Incubation Start Date',
      accessor: 'incubation_start_date',
    },
    {
      Header: 'surfaceMonitoringReport.Incubation End By',
      accessor: 'incubation_end_by',
    },
    {
      Header: 'surfaceMonitoringReport.Incubation End Date',
      accessor: 'incubation_end_date',
    },
    {
      Header: 'surfaceMonitoringReport.Incubation Duration',
      accessor: 'incubation_duration',
    },
    {
      Header: 'surfaceMonitoringReport.Second Incubation Start By',
      accessor: 'incubation2_started_by',
    },
    {
      Header: 'surfaceMonitoringReport.Second Incubation Start Date',
      accessor: 'incubation2_start_date',
    },
    {
      Header: 'surfaceMonitoringReport.Second Incubation End By',
      accessor: 'incubation2_end_by',
    },
    {
      Header: 'surfaceMonitoringReport.Second Incubation End Date',
      accessor: 'incubation2_end_date',
    },
    {
      Header: 'surfaceMonitoringReport.Second Incubation Duration',
      accessor: 'incubation2_duration',
    },
    {
      Header: 'surfaceMonitoringReport.Observer 1 Name',
      accessor: 'observer1_name',
    },
    {
      Header: 'surfaceMonitoringReport.Count 1',
      accessor: 'count1',
    },
    {
      Header: 'surfaceMonitoringReport.Observer 2 Name',
      accessor: 'observer2_name',
    },
    {
      Header: 'surfaceMonitoringReport.Count 2',
      accessor: 'count2',
    },
    {
      Header: 'surfaceMonitoringReport.Observer 3 Name',
      accessor: 'observer3_name',
    },
    {
      Header: 'surfaceMonitoringReport.Count 3',
      accessor: 'count3',
    },
    {
      Header: 'surfaceMonitoringReport.Approved By',
      accessor: 'approved_id',
    },
  
];

export const batchSummaryReport: TableColumn[] = [
  {
      Header: "batchSummaryReport.Sl.No",
      accessor: "slno",
  },
  {
    Header: "tableCommon.batch_code",
    accessor: "batch_code",
  },
  {
    Header: "batchSummaryReport.QR Generated On",
    accessor: "qr_generated_datetime",
  },
  {
    Header: "batchSummaryReport.Plate Type",
    accessor: "plate_size_type_name",
  },
  // {
  //   Header: "batchSummaryReport.Media Type",
  //   accessor: "media_type_name",
  // },
  {
    Header: "batchSummaryReport.Expiry Date",
    accessor: "expiry_date",
  },
  {
    Header: "tableCommon.seriel_number",
    accessor: "serial_number",
  },
  {
    Header: "batchSummaryReport.Lot Code",
    accessor: "lot_code",
  },
  {
    Header: "batchSummaryReport.Activity Name",
    accessor: "activity",
  },
  {
      Header: "batchSummaryReport.Area Name",
      accessor: "area_name",
  },
  {
      Header: "batchSummaryReport.Location Name",
      accessor: "location",
  },
  {
    Header: "batchSummaryReport.Equipment Name",
    accessor: "exposure_equipment_name",
  },
  {
    Header: "batchSummaryReport.Started Date/Time",
    accessor: "sampling_started_date",
  },
  {
      Header: "batchSummaryReport.Started By",
      accessor: "sampling_started_by",
  },
  {
      Header: "batchSummaryReport.Ended Date/Time",
      accessor: "sampling_ended_date",
  },
  {
      Header: "batchSummaryReport.Ended By",
      accessor: "sampling_ended_by",
  },
  {
      Header: "batchSummaryReport.Duration",
      accessor: "sampling_duration",
  },
  // {
  //     Header: "Test Tube Serial No",
  //     accessor: "test_tube_serial_no",
  // },
  // {
  //     Header: "Equipment Code",
  //     accessor: "equipment_code",
  // },
  {
    Header: "batchSummaryReport.Personnel Monitored Location",
    accessor: "monitored_location",
  },
  {
      Header: "batchSummaryReport.Personnel Monitored Assigned User",
      accessor: "monitored_user",
  },
  {
    Header: "batchSummaryReport.1st Incubator Name",
    accessor: "first_incubatior_name",
  },
  {
    Header: "batchSummaryReport.1st Incubation Started Date/Time",
    accessor: "first_incubation_start_date",
  },
  {
      Header: "batchSummaryReport.1st Incubation Started  By",
      accessor: "first_incubation_start_by",
  },
  {
    Header: "batchSummaryReport.1st Incubation End Date/Time",
    accessor: "first_incubation_end_date",
  },
  {
      Header: "batchSummaryReport.1st IncubationEnded By",
      accessor: "first_incubation_end_by",
  },
  {
      Header: "batchSummaryReport.1st Incubation Duration",
      accessor: "first_incubation_duration",
  },
  {
    Header: "batchSummaryReport.2nd Incubator Name",
    accessor: "second_incubatior_name",
  },
  {
    Header: "batchSummaryReport.2nd Incubation Started Date/Time",
    accessor: "second_incubation_start_date",
  },
  {
      Header: "batchSummaryReport.2nd Incubation Started By",
      accessor: "second_incubation_start_by",
  },
  {
    Header: "batchSummaryReport.2nd Incubation End Date/Time",
    accessor: "second_incubation_end_date",
  },
  {
      Header: "batchSummaryReport.2nd Incubation End By",
      accessor: "second_incubation_end_by",
  },
  {
      Header: "batchSummaryReport.2nd Incubation Duration",
      accessor: "second_incubation_duration",
  },
  {
    Header: "batchSummaryReport.Lab Area Name / Code",
    accessor: "lab_1_area_name",
  },
  {
      Header: "batchSummaryReport.1st Observer Name",
      accessor: "observer1_name",
  },
  {
      Header: "batchSummaryReport.1st Observer Count",
      accessor: "count1",
  },
  {
      Header: "batchSummaryReport.2nd Observer Name",
      accessor: "observer2_name",
  },
  {
      Header: "batchSummaryReport.2nd Observer Count",
      accessor: "count2",
  },
  {
      Header: "batchSummaryReport.3rd Observer Name",
      accessor: "observer3_name",
  },
  {
      Header: "batchSummaryReport.3rd Observer Count",
      accessor: "count3",
  },
  {
    Header: "batchSummaryReport.Approved By",
    accessor: "approved_user_name",
  },
  {
    Header: "batchSummaryReport.Approved Date / Time",
    accessor: "approved_date",
  },
  {
    Header: "batchSummaryReport.Approver Remarks",
    accessor: "approver_remarks",
  },
  {
    Header: "batchSummaryReport.Flora Conducted By",
    accessor: "flora_conducted_by",
  },
  {
    Header: "batchSummaryReport.Flora Conducted Date / Time",
    accessor: "flora_conducted_date",
  },
  {
      Header: "batchSummaryReport.Colony Type",
      accessor: "colony_type",
  },
  {
      Header: "batchSummaryReport.Organism Type",
      accessor: "organism_type",
  },
  {
      Header: "batchSummaryReport.Genus",
      accessor: "genus",
  },
  {
      Header: "batchSummaryReport.Species",
      accessor: "species",
  },
  {
      Header: "batchSummaryReport.Strain",
      accessor: "strain",
  },
  {
    Header: "batchSummaryReport.Autoclave Name",
    accessor: "autoclave_name",
  },
  {
    Header: "batchSummaryReport.Autoclave Started Date/Time",
    accessor: "autoclave_start_date",
  },
  {
      Header: "batchSummaryReport.Autoclave Started By",
      accessor: "autoclave_start_by",
  },
  {
    Header: "batchSummaryReport.Autoclave End Date/Time",
    accessor: "autoclave_end_date",
  },
  {
      Header: "batchSummaryReport.Autoclave End By",
      accessor: "autoclave_end_by",
  },
  {
      Header: "batchSummaryReport.Autoclave Duration",
      accessor: "autoclave_duration",
  },
  // {
  //     Header: "Plate Status",
  //     accessor: "plate_status",
  // },
  // {
  //     Header: "Approved ID",
  //     accessor: "approve_id",
  // },
];


export const nitrogenMonitoringColumns: TableColumn[] = [
  
    {
        Header: 'activeSamplingColumns.Sl.No',
        accessor: 'slno',
      },
      {
        Header: 'Production Schedule',
        accessor: 'production_schedule',
      },
      {
        Header: 'Product Name',
        accessor: 'product_name',
      },
      {
        Header: 'Area Name',
        accessor: 'area',
      },
      {
        Header: 'activeSamplingColumns.Location',
        accessor: 'location',
      },
      {
        Header: 'activeSamplingColumns.Serial Number',
        accessor: 'serial_number',
      },

      {
        Header: 'activeSamplingColumns.Batch Code',
        accessor: 'batch_number',
      },
      {
        Header: 'tableCommon.lot_code',
        accessor: 'lot_code',
      },
      {
        Header: 'activeSamplingColumns.Equipment Code',
        accessor: 'area_code',
      },
      {
        Header: 'activeSamplingColumns.Activity Started By',
        accessor: 'sampling_started_by',
      },
      {
        Header: 'activeSamplingColumns.Activity Started Date',
        accessor: 'start_date_time',
      },
      {
        Header: 'Activity End Date',
        accessor: 'activity_end_date_time',
      },
      {
        Header: 'activeSamplingColumns.Activity Duration',
        accessor: 'sampling_duration',
      },
      {
        Header: 'activeSamplingColumns.First Incubation Start By',
        accessor: 'incubation_started_by',
      },
      {
        Header: 'activeSamplingColumns.First Incubation Start Date',
        accessor: 'incubation_start_date',
      },
      {
        Header: 'activeSamplingColumns.First Incubation End By',
        accessor: 'incubation_end_by',
      },
      {
        Header: 'activeSamplingColumns.First Incubation End Date',
        accessor: 'incubation_end_date',
      },
      {
        Header: 'activeSamplingColumns.First Incubation Duration',
        accessor: 'incubation_duration',
      },
      {
        Header: 'activeSamplingColumns.Second Incubation Start By',
        accessor: 'incubation2_started_by',
      },
      {
        Header: 'activeSamplingColumns.Second Incubation Start Date',
        accessor: 'incubation2_start_date',
      },
      {
        Header: 'activeSamplingColumns.Second Incubation End By',
        accessor: 'incubation2_end_by',
      },
      {
        Header: 'activeSamplingColumns.Second Incubation End Date',
        accessor: 'incubation2_end_date',
      },
      {
        Header: 'activeSamplingColumns.Second Incubation Duration',
        accessor: 'incubation2_duration',
      },
      {
        Header: 'activeSamplingColumns.Observer 1 Name',
        accessor: 'observer1_name',
      },
      {
        Header: 'activeSamplingColumns.Count 1',
        accessor: 'count1',
      },
      {
        Header: 'activeSamplingColumns.Observer 2 Name',
        accessor: 'observer2_name',
      },
      {
        Header: 'activeSamplingColumns.Count 2',
        accessor: 'count2',
      },
      {
        Header: 'activeSamplingColumns.Observer 3 Name',
        accessor: 'observer3_name',
      },
      {
        Header: 'activeSamplingColumns.Count 3',
        accessor: 'count3',
      },
      {
        Header: 'activeSamplingColumns.Approved By',
        accessor: 'approved_id',
      },
  ];



  export const compressedAirColumns: TableColumn[] = [
  
    {
        Header: 'activeSamplingColumns.Sl.No',
        accessor: 'slno',
      },
      {
        Header: 'Production Schedule',
        accessor: 'production_schedule',
      },
      {
        Header: 'Product Name',
        accessor: 'product_name',
      },
      {
        Header: 'Area Name',
        accessor: 'area',
      },
      {
        Header: 'activeSamplingColumns.Location',
        accessor: 'location',
      },
      {
        Header: 'activeSamplingColumns.Serial Number',
        accessor: 'serial_number',
      },

      {
        Header: 'activeSamplingColumns.Batch Code',
        accessor: 'batch_number',
      },
      {
        Header: 'tableCommon.lot_code',
        accessor: 'lot_code',
      },
      {
        Header: 'activeSamplingColumns.Equipment Code',
        accessor: 'area_code',
      },
      {
        Header: 'activeSamplingColumns.Activity Started By',
        accessor: 'sampling_started_by',
      },
      {
        Header: 'activeSamplingColumns.Activity Started Date',
        accessor: 'start_date_time',
      },
      {
        Header: 'Activity End Date',
        accessor: 'activity_end_date_time',
      },
      {
        Header: 'activeSamplingColumns.Activity Duration',
        accessor: 'sampling_duration',
      },
      {
        Header: 'activeSamplingColumns.First Incubation Start By',
        accessor: 'incubation_started_by',
      },
      {
        Header: 'activeSamplingColumns.First Incubation Start Date',
        accessor: 'incubation_start_date',
      },
      {
        Header: 'activeSamplingColumns.First Incubation End By',
        accessor: 'incubation_end_by',
      },
      {
        Header: 'activeSamplingColumns.First Incubation End Date',
        accessor: 'incubation_end_date',
      },
      {
        Header: 'activeSamplingColumns.First Incubation Duration',
        accessor: 'incubation_duration',
      },
      {
        Header: 'activeSamplingColumns.Second Incubation Start By',
        accessor: 'incubation2_started_by',
      },
      {
        Header: 'activeSamplingColumns.Second Incubation Start Date',
        accessor: 'incubation2_start_date',
      },
      {
        Header: 'activeSamplingColumns.Second Incubation End By',
        accessor: 'incubation2_end_by',
      },
      {
        Header: 'activeSamplingColumns.Second Incubation End Date',
        accessor: 'incubation2_end_date',
      },
      {
        Header: 'activeSamplingColumns.Second Incubation Duration',
        accessor: 'incubation2_duration',
      },
      {
        Header: 'activeSamplingColumns.Observer 1 Name',
        accessor: 'observer1_name',
      },
      {
        Header: 'activeSamplingColumns.Count 1',
        accessor: 'count1',
      },
      {
        Header: 'activeSamplingColumns.Observer 2 Name',
        accessor: 'observer2_name',
      },
      {
        Header: 'activeSamplingColumns.Count 2',
        accessor: 'count2',
      },
      {
        Header: 'activeSamplingColumns.Observer 3 Name',
        accessor: 'observer3_name',
      },
      {
        Header: 'activeSamplingColumns.Count 3',
        accessor: 'count3',
      },
      {
        Header: 'activeSamplingColumns.Approved By',
        accessor: 'approved_id',
      },
  ];


  export const anaerobicMonitoringColumns: TableColumn[] = [
  {
      Header: 'passiveSamplingColumns.Sl.No',
      accessor: 'slno',
    },
    {
        Header: 'Production Schedule',
        accessor: 'production_schedule',
      },
      {
        Header: 'Product Name',
        accessor: 'product_name',
      },
      {
        Header: 'Area Name',
        accessor: 'area',
      },
    {
      Header: 'passiveSamplingColumns.Location',
      accessor: 'location',
    },
    {
      Header: 'passiveSamplingColumns.Serial Number',
      accessor: 'serial_number',
    },
    {
      Header: 'passiveSamplingColumns.Batch Code',
      accessor: 'batch_number',
    },
    {
      Header: 'tableCommon.lot_code',
      accessor: 'lot_code',
    },
    {
      Header: 'passiveSamplingColumns.Location Code',
      accessor: 'area_code',
    },
    {
      Header: 'passiveSamplingColumns.Activity Started By',
      accessor: 'started_by'
    },
    {
      Header: 'passiveSamplingColumns.Activity Started Date',
      accessor: 'start_date_time',
    },
    {
        Header: 'Activity End Date',
        accessor: 'activity_end_date_time',
      },
    {
      Header: 'passiveSamplingColumns.Activity Duration',
      accessor: 'sampling_duration',
    },
    {
      Header: 'passiveSamplingColumns.First Incubation Start By',
      accessor: 'incubation_started_by',
    },
    {
      Header: 'passiveSamplingColumns.First Incubation Start Date',
      accessor: 'incubation_start_date',
    },
    {
      Header: 'passiveSamplingColumns.First Incubation End By',
      accessor: 'incubation_end_by',
    },
    {
      Header: 'passiveSamplingColumns.First Incubation End Date',
      accessor: 'incubation_end_date',
    },
    {
      Header: 'passiveSamplingColumns.First Incubation Duration',
      accessor: 'incubation_duration',
    },
    {
      Header: 'passiveSamplingColumns.Second Incubation Start By',
      accessor: 'incubation2_started_by',
    },
    {
      Header: 'passiveSamplingColumns.Second Incubation Start Date',
      accessor: 'incubation2_start_date',
    },
    {
      Header: 'passiveSamplingColumns.Second Incubation End By',
      accessor: 'incubation2_end_by',
    },
    {
      Header: 'passiveSamplingColumns.Second Incubation End Date',
      accessor: 'incubation2_end_date',
    },
    {
      Header: 'passiveSamplingColumns.Second Incubation Duration',
      accessor: 'incubation2_duration',
    },
    {
      Header: 'passiveSamplingColumns.Observer 1 Name',
      accessor: 'observer1_name',
    },
    {
      Header: 'passiveSamplingColumns.Count 1',
      accessor: 'count1',
    },
    {
      Header: 'passiveSamplingColumns.Observer 2 Name',
      accessor: 'observer2_name',
    },
    {
      Header: 'passiveSamplingColumns.Count 2',
      accessor: 'count2',
    },
    {
      Header: 'passiveSamplingColumns.Observer 3 Name',
      accessor: 'observer3_name',
    },
    {
      Header: 'passiveSamplingColumns.Count 3',
      accessor: 'count3',
    },
    {
      Header: 'passiveSamplingColumns.Approved By',
      accessor: 'approved_id',
    },
  
];

export const plateSamplingColumns: TableColumn[] = [
  {
      Header: 'plateSamplingColumns.Sl.No',
      accessor: 'slno',
    },
    {
        Header: 'Production Schedule',
        accessor: 'production_schedule',
      },
      {
        Header: 'Product Name',
        accessor: 'product_name',
      },
    {
      Header: 'plateSamplingColumns.Serial Number',
      accessor: 'serial_number',
    },
    {
      Header: 'plateSamplingColumns.Batch Code',
      accessor: 'batch_number',
    },
    {
      Header: 'tableCommon.lot_code',
      accessor: 'lot_code',
    },
    // {
    //   Header: 'plateSamplingColumns.Location Code',
    //   accessor: 'area_code',
    // },
    {
      Header: 'plateSamplingColumns.Activity Started By',
      accessor: 'started_by'
    },
    {
      Header: 'plateSamplingColumns.Activity Started Date',
      accessor: 'start_date_time',
    },
    // {
    //     Header: 'Activity End Date',
    //     accessor: 'activity_end_date_time',
    //   },
    // {
    //   Header: 'plateSamplingColumns.Activity Duration',
    //   accessor: 'sampling_duration',
    // },
    {
      Header: 'plateSamplingColumns.First Incubation Start By',
      accessor: 'incubation_started_by',
    },
    {
      Header: 'plateSamplingColumns.First Incubation Start Date',
      accessor: 'incubation_start_date',
    },
    {
      Header: 'plateSamplingColumns.First Incubation End By',
      accessor: 'incubation_end_by',
    },
    {
      Header: 'plateSamplingColumns.First Incubation End Date',
      accessor: 'incubation_end_date',
    },
    {
      Header: 'plateSamplingColumns.First Incubation Duration',
      accessor: 'incubation_duration',
    },
    {
      Header: 'plateSamplingColumns.Second Incubation Start By',
      accessor: 'incubation2_started_by',
    },
    {
      Header: 'plateSamplingColumns.Second Incubation Start Date',
      accessor: 'incubation2_start_date',
    },
    {
      Header: 'plateSamplingColumns.Second Incubation End By',
      accessor: 'incubation2_end_by',
    },
    {
      Header: 'plateSamplingColumns.Second Incubation End Date',
      accessor: 'incubation2_end_date',
    },
    {
      Header: 'plateSamplingColumns.Second Incubation Duration',
      accessor: 'incubation2_duration',
    },
    {
      Header: 'plateSamplingColumns.Observer 1 Name',
      accessor: 'observer1_name',
    },
    {
      Header: 'plateSamplingColumns.Count 1',
      accessor: 'count1',
    },
    {
      Header: 'plateSamplingColumns.Observer 2 Name',
      accessor: 'observer2_name',
    },
    {
      Header: 'plateSamplingColumns.Count 2',
      accessor: 'count2',
    },
    {
      Header: 'plateSamplingColumns.Observer 3 Name',
      accessor: 'observer3_name',
    },
    {
      Header: 'plateSamplingColumns.Count 3',
      accessor: 'count3',
    },
    {
      Header: 'plateSamplingColumns.Approved By',
      accessor: 'approved_id',
    },
  
];



  interface TableColumn {
    Header: string;
    accessor: string;
  }